import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import { useAtom } from "jotai";
import { TTSCustomEditorColors } from "shared/constants";
import { shouldCloseMenuAtom } from "atoms";
import { EditorButtonStyles } from "shared/models";
import IconButtonWithTooltip from "./IconButtonWithTooltip";
import { Box } from "@mui/material";

interface CustomIconMenuProps {
  title: string;
  id: string;
  menuId?: string;
  component: React.ElementType;
  children?: React.ReactNode;
  width?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  color?: string;
  buttonStyles?: EditorButtonStyles;
  isActive: boolean;
  deleteButton?: React.ReactNode;
  disabled?: boolean;
}

function CustomIconMenu({
  title,
  id,
  menuId,
  component,
  children,
  width = "352px",
  onClick,
  color = TTSCustomEditorColors.ToolbarIconColor,
  buttonStyles,
  isActive,
  deleteButton,
  disabled = false,
}: CustomIconMenuProps): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [shouldCloseMenu, setShouldCloseMenu] = useAtom(shouldCloseMenuAtom);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setShouldCloseMenu(false);
    onClick?.(event);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (shouldCloseMenu) handleClose();
     
  }, [shouldCloseMenu]);

  return (
    <>
      <IconButtonWithTooltip
        tooltip={title}
        id={id}
        onClick={handleClick}
        icon={component}
        color={color}
        buttonStyles={buttonStyles}
        isActive={isActive}
        disabled={disabled}
      />
      {children && (
        <Menu
          id={menuId}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            sx: {
              boxShadow: "None",
              border: "1px solid #E0E0E0",
              borderRadius: "0",
              width,
            },
          }}
        >
          <Box sx={{ position: "relative" }}>
            {deleteButton}
            {children}
          </Box>
        </Menu>
      )}
    </>
  );
}

export default CustomIconMenu;
